import type { Editor } from "@tiptap/core";
import { useEffect, useState } from "react";

// Content above a table shifts it and its cells without changing their nodes, and these node views
// re-render only on a node change. `trackNodeViewPosition` would cover this, but tiptap 3.27 never
// subscribes it for a node view whose content target is not in the DOM yet — the table's case.
// Every subscribed node view re-renders on each keystroke above it, so `enabled = false` skips the
// subscription for views that do not need a live position and returns a plain `getPos()`.
const useNodeViewPosition = (editor: Editor, getPos: () => number | undefined, enabled = true) => {
	const [, setPos] = useState(getPos);

	useEffect(() => {
		if (!enabled) return;
		const onUpdate = () => {
			const pos = getPos();
			// A node view removed by this update (a deleted column) has no position: it is about to unmount
			if (pos !== undefined) setPos(pos);
		};
		editor.on("update", onUpdate);
		return () => {
			editor.off("update", onUpdate);
		};
	}, [editor, getPos, enabled]);

	return getPos();
};

export default useNodeViewPosition;
